import { createFileRoute } from '@tanstack/react-router';
import ChainSearchDetailPage from '../../views/dashboard-chain-searches/detail';

export const Route = createFileRoute('/dashboard/chains_/searches/$uuid')({
  component: ChainSearchDetailPage,
});
